module.exports = __webpack_public_path__ + "img/7.afb14466.png";